// https://fluentsite.z22.web.core.windows.net/quick-start
import React from "react";
import { Provider, teamsTheme } from "@fluentui/react-northstar";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import { useTeams } from "msteams-react-base-component";
import SharedFiles, { SharedFileSelector } from "./SharedFiles";
import * as microsoftTeams from "@microsoft/teams-js";
import { FileOpener } from "./FileOpener";

import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faCloudArrowUp, 
  faHouse, 
  faTurnUp, 
  faUpload, 
  faUsers, 
  faFile, 
  faFolderOpen, 
  faTrashCan,
  faRotateRight,
  faInfo
} from "@fortawesome/free-solid-svg-icons";
import TabConfig from "./Config";

library.add(faCloudArrowUp, faHouse, faTurnUp, faUpload, faUsers, faFile, faFolderOpen, faTrashCan, faRotateRight, faInfo);

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const { theme } = useTeams({})[0];

  // Initialize the Microsoft Teams SDK
  microsoftTeams.app.initialize();

  return (
    <Provider theme={theme || teamsTheme} styles={{ backgroundColor: "#eeeeee" }}>
      <HashRouter>
        <Switch>
          <Route exact path="/" component={SharedFiles} />
          <Route path="/files" component={SharedFiles} />
          <Route path="/selectSharedFile" component={SharedFileSelector} />
          <Route path="/openFile" component={FileOpener} />
          <Route path="/config" component={TabConfig} />
        </Switch>
      </HashRouter>
    </Provider>
  );
}
